import { Location } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import { StateService } from "@services/state.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";

@Component({
	selector: "app-landing",
	templateUrl: "./landing.component.html",
	styleUrls: ["./landing.component.scss"],
})
export class LandingComponent extends BaseFuncionalidadComponent {
	constructor(
		sessionService: SessionService,
        router: Router,
        route: ActivatedRoute,
        location: Location,
        stateService: StateService
	) {
		super(route, sessionService, location, router, stateService);
	}

	navigateTo(path: string) {
		this.router.navigate([path]);
	}

	// el usuario esta logueado
	get isAuthenticated(): boolean {
		return this.sessionService.isAuthenticated();
	}

	// maneja cual es el perfil seleccionado actualmente por el usuario
	get rolActual() {
		return this.sessionService.rolActual;
	}

	// maneja el nombre del usuario que inicio sesion
	get nombreUsuario(): string {
		return this.sessionService.getSesionActual().getNombreCompleto();
	}

    get nombreRolSeleccionado(): string {
        const sesion = this.sessionService.getSesionActual();
        const rol = sesion?.terminologia?.roles?.find(r => r.codigo === this.sessionService.rolActual);
        return rol ? rol.nombre : '';
    }
}
